<template>
  <div class="rewards" :class="cssType">
    <!-- <div class="rewards-title" :class="locale"></div> -->
    <img :src="cssType === 'mobile' ? rewardsTitleImgMobile : rewardsTitleImg" alt="rewardsTitle" class="rewards-title" :class="locale">
    <div class="rewards-texts">
      <p class="text-1">
        <i18n-t keypath="accum.rewards.eventDesc" tag="span">
          <template #clickHere>
            <span class="accum-link" @click="goRecharge">
              {{ $t('accum.clickHere') }}
            </span>
          </template>
        </i18n-t>
        <!-- {{ $t('accum.rewards.eventDesc', { clickHere: $t('accum.clickHere') }) }} -->
      </p>
      <p class="text-2">
        <i18n-t keypath="accum.rewards.eventDescDuojin" tag="span">
          <template #duojin>
            <span class="duojin">
              {{ $t('accum.rewards.duojin') }}
            </span>
          </template>
        </i18n-t>
      </p>
      <p class="text-2">{{ $t('accum.rewards.eventTime') }}</p>
      <p class="text-3">{{ $t('accum.rewards.rewardEndTime') }}</p>
    </div>
    <div class="rewards-btns">
      <AccumButton @click="goRecharge">{{ $t('accum.goRecharge') }}</AccumButton>
      <AccumButton @click="showRecordDialog">{{ $t('accum.record') }}</AccumButton>
      <AccumButton :type="state.canReceiveOneKey ? 'green' : 'grey'" :disabled="!state.canReceiveOneKey" @click="rewardsAll">{{ $t('accum.rewardsAll') }}</AccumButton>
    </div>
    <div class="rewards-box" :class="locale">
      <div class="rewards-box-bg-1"></div>
      <div class="rewards-box-bg-2"></div>
      <div class="rewards-box-bg-3"></div>
      <div class="diff-diamond" v-html="diffDiamond"></div>
      <div class="rewards-list">
        <div
          class="rewards-item"
          :class="{ active: props.rechargeDiamond >= item.needPurchaseCount && item.status === 'canReceive', 'not-reach': props.rechargeDiamond < item.needPurchaseCount, [locale]: true }"
          v-for="(item, index) in props.rewardList"
          :key="index"
        >
          <div class="props-img-list">
            <div
              class="props-img-row"
              v-for="(row, i) in propsToRows(item.propsGift)"
              :key="i"
              :class="{'set-margin-top': calcSetMarginTop(row, i, propsToRows(item.propsGift))}"
            >
              <div class="props-img-item" v-for="(prop, j) in row" :key="j">
                <img :src="prop.iconUrl" :alt="prop.name">
              </div>
            </div>
            <!-- <div class="props-img-item" :class="'lenth-' + JSON.parse(item.propsGift).length" v-for="(prop, i) in JSON.parse(item.propsGift)" :key="i">
              <img :src="prop.iconUrl" :alt="prop.name">
            </div> -->
          </div>
          <div class="props-detail-list" :class="locale">
            <div class="props-detail-item" v-for="(prop, i) in JSON.parse(item.propsGift)" :key="i">
              <div class="name">{{ prop.name }}*{{ formatNum(prop.count) }}</div>
              <div class="num"></div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="rewards-btn-list">
        <div class="rewards-btn-item" v-for="item in props.rewardList" :key="item.id">
          <div class="receive-btn can-receive" :class="locale" @click="handleReceiveReward(item)" v-if="item.status === 'canReceive'">{{ $t('accum.rewards.btnCanReceive') }}</div>
          <div class="receive-btn received" :class="locale" v-else-if="item.status === 'received'">{{ $t('accum.rewards.btnReceived') }}</div>
          <div class="receive-btn not-reach" :class="locale" v-else-if="item.status === 'notReach'">{{ $t('accum.rewards.btnNotReach') }}</div>
          <div class="receive-btn go-recharge" :class="locale" @click="goRecharge" v-else-if="item.status === 'goRecharge'">{{ $t('accum.goRecharge') }}</div>
          <div class="diamond-num" :class="{ 'not-reach': props.rechargeDiamond < item.needPurchaseCount }">
            <span>
              {{ item.needPurchaseCount }}
            </span>
            <span>
              {{ $t('payment.product.diamond') }}
            </span>
          </div>
        </div>
      </div>
      <ProgressBar class="progress-bar" :list="props.rewardList" :rechargeDiamond="props.rechargeDiamond" />
    </div>
    <Dialog v-model="state.rewardsAllDialog.visible" type="common">
      <div class="rewards-all-dialog-content">
        <div class="dialog-title">{{ $t('accum.rewardsAllDialog.title') }}</div>
        <div class="dialog-content">
          <div class="dialog-content-item" v-for="(item, index) in rewardsAllDialogContent" :key="index">
            <span v-html="item"></span>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.notStartDialog.visible" type="common" :showClose="false">
      <div class="not-start-dialog-content">
        <div class="dialog-title">{{ $t('payment.tip') }}</div>
        <div class="dialog-content">
          <p>{{ $t('payment.notStart') }}</p>
          <p>{{ $t('accum.rewards.eventTime') }}</p>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.receiveRewardDialog.visible" type="large" :size="state.receiveRewardDialog.size">
      <div class="receive-reward-dialog-content">
        <div class="dialog-title">{{ $t('accum.rewardsAllDialog.title') }}</div>
        <div class="dialog-content" :class="state.receiveRewardDialog.size">
          <div class="receive-reward-item" v-for="(item, index) in JSON.parse(state.receiveRewards.propsGift)" :key="index">
            <div class="receive-reward-item-icon">
              <div class="img-wapper">
                <img class="img" :src="item.iconUrl" :alt="item.name">
              </div>
            </div>
            <div class="receive-reward-item-name">
              {{ item.name }} *
            </div>
            <div class="receive-reward-item-num">
              {{ formatNum(item.count) }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog v-model="state.recordDialog.visible" type="common">
      <div class="record-dialog-content">
        <div class="dialog-title">{{ $t('accum.recordDialog.title') }}</div>
        <div class="dialog-content">
          <div class="record-table">
            <div class="thead">
              <div class="tr">
                <div class="th reach-node">
                  {{ $t('accum.recordDialog.reachNode') }}
                </div>
                <div class="th details">
                  {{ $t('accum.recordDialog.details') }}
                </div>
                <div class="th time">
                  {{ $t('accum.recordDialog.time') }}
                </div>
              </div>
            </div>
            <div class="tbody" v-if="state.rewardRecordList.length > 0">
              <div class="tr" v-for="item in state.rewardRecordList" :key="item.id">
                <div class="td reach-node">
                  {{ item.needPurchaseCount }} {{ $t('payment.product.diamond') }}
                </div>
                <div class="td details">
                  <div class="details-item" v-for="(prop, index) in JSON.parse(item.propsGift)" :key="index">
                    {{ prop.name }} * {{ formatNum(prop.count) }}
                  </div>
                </div>
                <div class="td time">
                  {{ item.createTime }}
                </div>
              </div>
            </div>
            <div class="empty-data" v-else>
              {{ $t('payment.noData') }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { computed, reactive, watch, defineEmits, defineProps } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import AccumButton from '../AccumButton'
import ProgressBar from './components/ProgressBar'
import Dialog from '@/components/Dialog/ActAccum/index.vue'
import AccumApi from '@/config/accumApi'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
import { useLog } from '@/composables/useLog'
import { useRouter } from 'vue-router'
import rewardsTitleImg from '@/views/act/midAutumnAccum2026/assets/imgs/rewardsTitle/index.js'
import rewardsTitleImgMobile from '@/views/act/midAutumnAccum2026/assets/imgs/mobile/rewardsTitle/index.js'
const router = useRouter()
const log = useLog()
const store = useStore()
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const emit = defineEmits(['dialogOpen', 'rewarded'])
const formatNum = (num) => {
  if (num < 1000) {
    return num
  }
  if (num < 1000000 * 10) { // 1000K=1M，但是运营要求不展示1-9M，1-9M展示为1000K-9000K，最少都是展示10M。
    return parseFloat((num / 1000).toFixed(1)) + 'K'
  }
  return parseFloat((num / 1000000).toFixed(1)) + 'M'
}
const props = defineProps({
  rewardList: {
    type: Array,
    default: () => [],
  },
  rechargeDiamond: {
    type: Number,
    default: 0,
  },
})
const state = reactive({
  cpUserInfo: computed(() => store.state.cpUserInfo),
  nextDiffDiamondNum: computed(() => {
    let res = 0;
    props.rewardList.find(item => {
      if (props.rechargeDiamond < item.needPurchaseCount) {
        res = item.needPurchaseCount - props.rechargeDiamond
        return true
      }
      return false
    })
    return res
  }),
  canReceiveAll: computed(() => { // 是否可以一键领取
    return props.rewardList.every(item => {
      return props.rechargeDiamond >= item.needPurchaseCount
    })
  }),
  receiveRewards: {},
  rewardRecordList: [],
  recordDialog: {
    visible: false,
  },
  rewardsAllDialog: {
    visible: false,
  },
  receiveRewardDialog: {
    visible: false,
    size: 'normal'
  },
  notStartDialog: {
    visible: false,
  },
  canReceiveOneKey: computed(() => { // 是否可以一键领取
    return props.rewardList.some(item => item.status === 'canReceive')
  }),
})

const propsToRows = (propsJSON) => {
  const props = JSON.parse(propsJSON)
  const res = [
    [],
    [],
    []
  ]
  switch (props.length) {
    case 1:
      res[0] = [...props]
      break
    case 2:
      res[0] = [...props]
      break
    case 3:
      res[0] = [...props]
      break
    case 4:
      res[0] = [...props.slice(0, 2)]
      res[1] = [...props.slice(2, 4)]
      break
    case 5:
      res[0] = [...props.slice(0, 3)]
      res[1] = [...props.slice(3, 5)]
      break
    case 6:
      res[0] = [...props.slice(0, 3)]
      res[1] = [...props.slice(3, 6)]
      break
    case 7:
      res[0] = [...props.slice(0, 2)]
      res[1] = [...props.slice(2, 5)]
      res[2] = [...props.slice(5, 7)]
      break
    case 8:
      res[0] = [...props.slice(0, 3)]
      res[1] = [...props.slice(3, 6)]
      res[2] = [...props.slice(6, 8)]
      break
    default:
      res[0] = [...props.slice(0, 3)]
      res[1] = [...props.slice(3, 6)]
      res[2] = [...props.slice(6, props.length)]
      break
  }
  return res
}

const calcSetMarginTop = (row, index, rows) => {
  const prevRow = rows[index - 1]
  if (index === 0) {
    return false
  }
  if (!prevRow) {
    return false
  }
  if (prevRow.length === row.length) {
    return false
  }
  return true
}

// watch(() => state.cpUserInfo, () => {
//   reset()
// }, { deep: true })
// watch(() => store.state.locale, () => {
//   reset()
// })
watch(() => state.receiveRewardDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.rewardsAllDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.recordDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
watch(() => state.notStartDialog.visible, (newVal) => {
  emit('dialogOpen', newVal)
})
// const eventDesc = computed(() => {
//   const text = t('accum.rewards.eventDesc')
//   return text.replace('[clickHere]', `
//   <a href="${payUrl.value}" class="accum-link" target="_blank">
//     [${t('accum.clickHere')}]
//   </a>
//   `)
// })
const diffDiamond = computed(() => {
  if (state.canReceiveAll) {
    return t('accum.rewards.canReceiveAll')
  }
  const text = t('accum.rewards.diffDiamond')
  return text.replace('[diamondNum]', `
  <span style="color: #E9C452;">
    ${state.nextDiffDiamondNum}
  </span>
  `)
})
const rewardsAllDialogContent = computed(() => {
  const text = t('accum.rewardsAllDialog.content')
  const texts = text.split('\n')
  return texts.map(item => {
    return item.replace('[record]', `
      <span style="color: #5A90FF;">[${t('accum.record')}]</span>
    `)
  })
})
const goRecharge = () => {
  log.track('act_accum_recharge')
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}

// const getRewardList = async () => {
//   const params = {
//     accountNum: state.cpUserInfo.accountNum,
//   }
//   const res = await AccumApi.getRewardList(params)
//   const list = res.list || []
//   list.sort((a, b) => a.needPurchaseCount - b.needPurchaseCount)
//   list.forEach(item => {
//     item.status = getStatus(item)
//   })
//   state.rewardList = res.list || []
//   state.rechargeDiamond = res.totalMergePrdCount || 0
//   // let maxActivityStartTimestamp = 0
//   // list.forEach(item => {
//   //   if(!maxActivityStartTimestamp || item.activityStartTimestamp > maxActivityStartTimestamp) {
//   //     maxActivityStartTimestamp = item.activityStartTimestamp
//   //   }
//   // })
//   // console.log('maxActivityStartTimestamp', maxActivityStartTimestamp)
//   // const serverTime = res.timestamp * 1000
//   // const startTimestamp = maxActivityStartTimestamp * 1000
//   // console.log('serverTime', new Date(serverTime).toLocaleString(), 'startTimestamp', new Date(startTimestamp).toLocaleString(), serverTime < startTimestamp)
//   // if (serverTime && startTimestamp && serverTime < startTimestamp) {
//   //   state.notStartDialog.visible = true
//   //   countDownHideNotStartDialog(serverTime, startTimestamp)
//   // }
// }

// // 计算时间，关闭弹窗
// const countDownHideNotStartDialog = (serverTime, startTimestamp) => {
//   // 计算服务器时间与设备时间的差异
//   const serverToLocalDiff = serverTime - Date.now();

//   const interval = setInterval(() => {
//     // 将当前设备时间转换为服务器时间
//     const now = Date.now() + serverToLocalDiff;
//     if (now >= startTimestamp) {
//       clearInterval(interval);
//       state.notStartDialog.visible = false;
//     }
//   }, 1000);
// }

const getRewardRecordList = async () => {
  const activityIds = (props.rewardList || []).map(item => item.activityId)
  const params = {
    accountNum: state.cpUserInfo.accountNum,
    activityIds,
  }
  const res = await AccumApi.getRewardRecordList(params)
  console.log('getRewardRecordList', res)
  // debugger
  if (res.list) {
    state.rewardRecordList = res.list.sort((a, b) => new Date(b.createTime).getTime() - new Date(a.createTime).getTime())
  } else {
    state.rewardRecordList = []
  }
  
}

const showRecordDialog = async () => {
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  log.track('act_accum_record')
  getRewardRecordList()
  state.recordDialog.visible = true
}

const rewardsAll = () => {
  console.log('rewardsAll', state.cpUserInfo.cpUserId, state.canReceiveOneKey)
  if (!state.cpUserInfo.cpUserId) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (!state.canReceiveOneKey) {
    return
  }
  oneKeyCollect()
}

const oneKeyCollectTrack = () => {
  try {
    props.rewardList.forEach(item => {
      if (item.status === 'canReceive') {
        const propsGift = JSON.parse(item.propsGift)
        log.track('act_accum_receive_reward', {
          v1: JSON.stringify(propsGift.map(item => {
            return {
              id: item.id,
              name: item.name,
              count: item.count,
            }
          })),
          v2: item.needPurchaseCount,
        })
      }
    })
  } catch (error) {
    console.error(error)
  }
}
const oneKeyCollect = async () => {
  oneKeyCollectTrack()
  const params = {
    accountNum: state.cpUserInfo.accountNum,
  }
  const res = await AccumApi.oneKeyCollect(params)
  console.log('oneKeyCollect', res)
  state.rewardsAllDialog.visible = true
  emit('rewarded')
}

// const getStatus = (item) => {
//   // collectTimesLimit 奖励领取次数上限(活动配置)
//   // collectedTimes 已领奖励次数
//   // canCollectTimes 当前可领奖励次数上限
//   if (item.collectTimesLimit === 0) { // 奖励领取时间结束后，服务端collectTimesLimit会返回0，统一展示goRecharge按钮
//     return 'goRecharge'
//   }
//   if (item.collectedTimes >= item.collectTimesLimit) {
//     return 'received'
//   }
//   if (item.collectedTimes < item.canCollectTimes) {
//     return 'canReceive'
//   }
//   if (item.canCollectTimes < item.collectTimesLimit) {
//     return 'notReach'
//   }
//   console.error('getStatus error', item)
// }
// setTimeout(() => {
//   state.receiveRewards = props.rewardList[7]
//   state.receiveRewardDialog.visible = true
//   const propsGift = JSON.parse(state.receiveRewards.propsGift)
//   if (propsGift.length > 3) {
//     state.receiveRewardDialog.size = 'large'
//   } else {
//     state.receiveRewardDialog.size = 'normal'
//   }
//   emit('rewarded')
// }, 1000)
const handleReceiveReward = async (item) => {
  state.receiveRewards = item
  const params = {
    buyId: item.buyId,
  }
  const res = await AccumApi.collectReward(params)
  console.log('collectReward', res)
  try {
    const propsGift = JSON.parse(state.receiveRewards.propsGift)
    log.track('act_accum_receive_reward', {
      v1: JSON.stringify(propsGift.map(item => {
        return {
          id: item.id,
          name: item.name,
          count: item.count,
        }
      })),
      v2: item.needPurchaseCount,
    })
    if (propsGift.length > 3) {
      state.receiveRewardDialog.size = 'large'
    } else {
      state.receiveRewardDialog.size = 'normal'
    }
  } catch (error) {
    console.error(error)
  }
  state.receiveRewardDialog.visible = true
  emit('rewarded')
}

</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
<style lang="less" scoped>
.duojin {
  color: #F54C45;
  font-weight: bold;
}
</style>